export default __webpack_public_path__ + "static/media/workPlacement.bc8ed3cb.png";